var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('div', {
    attrs: {
      "else": ""
    }
  }, [_vm.$route.params.items == `Most Popular` ? _c('sections-slider', {
    attrs: {
      "list": _vm.itemSuggestions,
      "subTitle": _vm.$route.params.items,
      "showTitle": true,
      "hasBackground": false,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref) {
        var listItem = _ref.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 1522884298)
  }) : _vm._e(), _vm.$route.params.items == `Daily Essentials` ? _c('sections-slider', {
    attrs: {
      "list": _vm.newArrivals,
      "subTitle": _vm.$route.params.items,
      "showTitle": true,
      "hasBackground": false,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref2) {
        var listItem = _ref2.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 1522884298)
  }) : _vm._e(), _vm.$route.params.items == `Recommended Stores` ? _c('sections-slider', {
    attrs: {
      "list": _vm.recommendedStores,
      "subTitle": _vm.$route.params.items,
      "hasBackground": false,
      "showTitle": true,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref3) {
        var listItem = _ref3.listItem;
        return [_c('div', {
          staticClass: "item-box product-listing-div"
        }, [_c('router-link', {
          staticStyle: {
            "text-decoration": "none",
            "color": "inherit"
          },
          attrs: {
            "to": {
              name: `shopDetails`,
              params: {
                id: listItem._id,
                name: listItem.office.officeName
              }
            }
          }
        }, [_c('items-item', {
          attrs: {
            "itemWhiteBg": true,
            "product": listItem
          }
        })], 1)], 1)];
      }
    }], null, false, 2390524651)
  }) : _vm._e(), _vm.$route.params.items == `Whats Trending` ? _c('sections-slider', {
    attrs: {
      "list": _vm.whatsTrending,
      "subTitle": _vm.$route.params.items,
      "showTitle": true,
      "hasBackground": false,
      "hasButton": false,
      "withoutSlider": true
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function (_ref4) {
        var listItem = _ref4.listItem;
        return [_c('div', {
          staticClass: "item-box"
        }, [_c('items-item', {
          attrs: {
            "itemNoBg": true,
            "product": listItem,
            "incrementDecrementKey": true
          }
        })], 1)];
      }
    }], null, false, 1522884298)
  }) : _vm._e()], 1)]);

}
var staticRenderFns = []

export { render, staticRenderFns }